export default class TableHelperData {
  public idRoad: number = 0;
  public idSegment: number = 0;
  public idSession: number = 0;
  public startDistance: number = 0;
  public endDistance: number = 0;
  public startChainage: number = 0;
  public endChainage: number = 0;
}
